import { FUNNEL_STATUS_LABELS, PIPELINE_ORDER } from '../utils/funnelStatusLabels';

const WebsitesList = ({ 
    websites, 
    onSelect, 
    selectedWebsiteHash,
    currentPage,
    totalHits,
    itemsPerPage,
    onPageChange,
    funnelStatusAggregation = {},
    selectedFunnelStatus,
    onFunnelStatusChange
}) => {
    // Get all funnel status values from aggregation (excluding __all__)
    const funnelStatuses = Object.keys(funnelStatusAggregation)
        .filter(key => key !== '__all__')
        .sort((a, b) => PIPELINE_ORDER.indexOf(a) - PIPELINE_ORDER.indexOf(b));
    const hasTabs = Object.keys(funnelStatusAggregation).length > 0;

    const totalPages = Math.ceil(totalHits / itemsPerPage);

    const handleClick = (website) => {
        if (onSelect && website._source && website._source.url_hash) {
            onSelect(website._source.url_hash, website);
        }
    };

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    return (
        <div>
            {/* Tabs for funnel_status */}
            {hasTabs && (
                <div style={{ 
                    display: 'flex', 
                    flexWrap: 'wrap',
                    gap: '4px',
                    marginBottom: '10px',
                    paddingBottom: '10px',
                    borderBottom: '1px solid #404040'
                }}>
                    {/* All tab */}
                    {funnelStatusAggregation['__all__'] !== undefined && (
                        <button
                            onClick={() => onFunnelStatusChange && onFunnelStatusChange('__all__')}
                            style={{
                                padding: '4px 8px',
                                backgroundColor: selectedFunnelStatus === '__all__' ? '#64b5f6' : '#2d2d2d',
                                color: selectedFunnelStatus === '__all__' ? '#ffffff' : '#e0e0e0',
                                border: '1px solid #404040',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '11px',
                                fontWeight: selectedFunnelStatus === '__all__' ? 'bold' : 'normal'
                            }}
                        >
                            All ({funnelStatusAggregation['__all__']})
                        </button>
                    )}
                    {/* Individual status tabs */}
                    {funnelStatuses.map((status) => {
                        const isActive = selectedFunnelStatus === status;
                        const count = funnelStatusAggregation[status] || 0;
                        return (
                            <button
                                key={status}
                                onClick={() => onFunnelStatusChange && onFunnelStatusChange(status)}
                                style={{
                                    padding: '4px 8px',
                                    backgroundColor: isActive ? '#64b5f6' : '#2d2d2d',
                                    color: isActive ? '#ffffff' : '#e0e0e0',
                                    border: '1px solid #404040',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '11px',
                                    fontWeight: isActive ? 'bold' : 'normal'
                                }}
                            >
                                {FUNNEL_STATUS_LABELS[status] || status || 'null'} ({count})
                            </button>
                        );
                    })}
                </div>
            )}

            {/* Websites List */}
            {!websites || websites.length === 0 ? (
                <div>
                    <p style={{ color: '#a0a0a0', fontSize: '12px' }}>No websites found</p>
                </div>
            ) : (
                <ul className="list-group" style={{ listStyle: 'none', padding: 0, marginBottom: '10px' }}>
                    {websites.map((website, index) => {
                        let url = website._source?.main_url || website._id || 'Unknown';
                        url = url.replace(/^https?:\/\//, '');
                        
                        const hash = website._source?.url_hash || null;
                        const isSelected = selectedWebsiteHash === hash;
                        return (
                            <li 
                                key={website._id || index}
                                onClick={() => handleClick(website)}
                                style={{ 
                                    cursor: 'pointer',
                                    border: 0,
                                    marginBottom: '4px',
                                    fontWeight: isSelected ? 'bold' : 'normal',
                                    color: isSelected ? '#64b5f6' : '#e0e0e0'
                                }}
                            >
                                {url}
                            </li>
                        );
                    })}
                </ul>
            )}

            {/* Pagination Controls */}
            {totalHits > 0 && (
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    marginTop: '10px',
                    paddingTop: '10px',
                    borderTop: '1px solid #404040'
                }}>
                    <button
                        onClick={() => goToPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                            padding: '4px 8px',
                            backgroundColor: currentPage === 1 ? '#404040' : '#2d2d2d',
                            color: '#e0e0e0',
                            border: '1px solid #404040',
                            borderRadius: '4px',
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                            fontSize: '12px',
                            opacity: currentPage === 1 ? 0.5 : 1
                        }}
                    >
                        Previous
                    </button>
                    <span style={{ color: '#a0a0a0', fontSize: '12px' }}>
                        Page {currentPage} of {totalPages || 1}
                    </span>
                    <button
                        onClick={() => goToPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                            padding: '4px 8px',
                            backgroundColor: currentPage === totalPages ? '#404040' : '#2d2d2d',
                            color: '#e0e0e0',
                            border: '1px solid #404040',
                            borderRadius: '4px',
                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                            fontSize: '12px',
                            opacity: currentPage === totalPages ? 0.5 : 1
                        }}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default WebsitesList;

